<template>
	<div>
		<el-dialog title="" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
			<!-- 登录 -->
			<div class="loginBox">
				<!-- 头部logo -->
				<div class="logoBox">
					<!-- <img src="@/assets/logos.png" style="height:70px" /> -->
				</div>
				<div style="font-size: 30px;">乐乐智能山东中职网管理平台软件</div>
				<!-- 登录区域开始 -->
				<div class="loginInput" v-if="loginType!=2">
					<!-- 账号登录框 -->
					<div class="accountBox">
						<el-input v-model="account" placeholder="请输入登录账号">
							<i slot="prefix" class="el-icon-user"></i>
						</el-input>
					</div>
					<!-- 密码输入框 -->
					<div class="psBox">
						<!-- 密码登录 -->
						<el-input v-if="loginType===1" v-model="psValue" placeholder="请输入登录密码" show-password>
							<i slot="prefix" class="el-icon-lock"></i>
						</el-input>
						<!-- 二维码登录 -->
						<el-input v-else-if="loginType===0" v-model="codeValue" placeholder="请输入验证码">
							<i slot="prefix" class="el-icon-lock"></i>
							<div v-if="codeTime===120" slot="suffix" class="getCodeBox" @click="getCode">
								{{getCodeText}}
							</div>
							<div v-else slot="suffix" class="getCodeBox">
								{{codeTime}}秒后重试
							</div>
						</el-input>
					</div>
				</div>
				<!-- 密码登录还是验证码登录 -->
				<div class="is_psBox" v-if="loginType!=2">
					<div v-if="loginType===0" @click="loginType=1">
						密码登录
					</div>
					<div v-else-if="loginType===1" @click="loginType=0">
						验证码登录
					</div>
				</div>
				<!-- 登录按钮 -->
				<div class="loginBtn" @click="loginBtn" v-if="loginType!=2">
					登录
				</div>
				<!-- 底部注册框 -->
				<div class="registerBox" @click="toRegister" v-if="loginType!=2">
					注册
				</div>
				<!-- 登录区域结束 -->
				<!-- 注册区域开始 -->
				<div class="loginInput" v-if="loginType==2">
					<!-- 账号登录框 -->
					<div class="accountBox">
						<el-input v-model="account" placeholder="请输入登录账号">
							<i slot="prefix" class="el-icon-user"></i>
						</el-input>
					</div>
					<!-- 密码输入框 -->
					<div class="psBox">
						<!-- 获取二维码 -->
						<el-input v-model="codeValue" placeholder="请输入验证码">
							<i slot="prefix" class="el-icon-lock"></i>
							<div v-if="codeTime===120" slot="suffix" class="getCodeBox" @click="getCode">
								{{getCodeText}}
							</div>
							<div v-else slot="suffix" class="getCodeBox">
								{{codeTime}}秒后重试
							</div>
						</el-input>

					</div>
					<div class="psBox">
						<!-- 输入密码 -->
						<el-input v-model="psValue" placeholder="请输入登录密码" show-password>
							<i slot="prefix" class="el-icon-lock"></i>
						</el-input>
					</div>
					<div class="psBox">
						<!-- 确认密码 -->
						<el-input v-model="psValue2" placeholder="请再次输入密码" show-password>
							<i slot="prefix" class="el-icon-lock"></i>
						</el-input>
					</div>
				</div>
				<div class="loginBtn" style="margin-top: 20px;" @click="registerBtn" v-if="loginType==2">
					注册
				</div>
				<div class="registerBox" @click="loginType=1" v-if="loginType==2">
					登录
				</div>
				<!-- 注册区域结束 -->
				
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		phoneNumber,
		verificationCode, //获取验证码
		studentLogin, //密码登录
		codeLogin, //验证码登录
		signin,//注册
	} from '@/api/index'
	import md5 from '../../MD5/md5.js'
	export default {
		data() {
			return {
				loginType: 1, //0短信登录 1密码登录 2 注册
				dialogVisible: false, //弹窗显示
				account: '', //账号
				psValue: '', //密码
				codeValue: '', //验证码
				codeTime: 120, //验证码递减
				getCodeText: '获取验证码',
				psValue2:'',//第二次输入密码
			};
		},
		methods: {
			//关闭页面
			handleClose(done) {
				done()
			},
			//去注册
			toRegister() {
				console.log('点击了去注册')
				this.loginType = 2
			},
			//注册按钮
			registerBtn(){
				let _this=this
				if (_this.account == '') {
					_this.$message.error('请填写手机号');
					return
				}
				if (_this.account.length != 11) {
					_this.$message.error('请填写11位手机号');
					return
				}
				if (_this.codeValue.length != 4) {
					_this.$message.error('请输入4位数验证码');
					return
				}
				if (_this.psValue == '') {
					_this.$message.error('请填写密码');
					return
				}
				if (_this.psValue.length < 6 || _this.psValue.length > 18) {
					_this.$message.error('请填写6-18位密码');
					return
				}
				if (_this.psValue!= _this.psValue2) {
					_this.$message.error('两次密码输入不一致');
					return
				}
				let codeHash = md5(_this.codeValue).toLocaleUpperCase()
				codeHash = md5(codeHash).toLocaleUpperCase()
				let hash = md5(_this.psValue).toLocaleUpperCase()
				signin({
					loginAccount:_this.account,
					loginPwd:hash,
					verificationCode:codeHash
				}).then(res=>{
					if(res.code===0){
						setTimeout(()=>{
							_this.$message.success(res.message);
						},200)
						_this.loginType = 0
						// 登录
						_this.loginBtn()
					}
				})
			},
			//去登录
			loginBtn() {
				let _this = this
				if (_this.account == '') {
					_this.$message.error('请填写手机号');
					return
				}
				if (_this.account.length != 11) {
					_this.$message.error('请填写11位手机号');
					return
				}
				//验证码登录
				if (_this.loginType == 0) {
					console.log('这是短信登录')
					if (_this.codeValue.length != 4) {
						_this.$message.error('请输入4位数验证码');
						return
					}
					//验证码转md5
					let codeHash = md5(_this.codeValue).toLocaleUpperCase()
					codeHash = md5(codeHash).toLocaleUpperCase()
					codeLogin({
						loginAccount: _this.account,
						verificationCode: codeHash
					}).then(suc => {
						if (suc.code == 0) {
							// 登录成功 缓存用户信息
							localStorage.setItem('loginAccount', suc.data.loginAccount)
							localStorage.setItem('orgID', suc.data.orgID)
							localStorage.setItem('role', suc.data.role)
							localStorage.setItem('smartCampusToken', suc.data.smartCampusToken)
							localStorage.setItem('userID', suc.data.userID)
							localStorage.setItem('userIdentity', suc.data.userIdentity)
							_this.$message.success('登录成功');
							this.$emit('updateStatus')
							//关闭弹窗
							_this.dialogVisible = false
						} else {
							_this.$message.error(suc.message);
						}
					})
				} else if (_this.loginType == 1) {
					// 密码登录
					if (_this.psValue == '') {
						_this.$message.error('请填写密码');
						return
					}
					if (_this.psValue.length < 6 || _this.psValue.length > 18) {
						_this.$message.error('请填写6-18位密码');
						return
					}
					//检查是否注册过
					phoneNumber(_this.account).then(res => {
						console.log('打印是否注册过', res, _this.psValue)
						if (res.message == 1) {
							let hash = md5(_this.psValue).toLocaleUpperCase()
							console.log('没有注册过')
							studentLogin({
								loginAccount: _this.account,
								loginPwd: hash
							}).then(resS => {
								console.log('打印账号密码登录的resSS', resS)
								if (resS.code == 0) {
									// 登录成功 缓存用户信息
									localStorage.setItem('loginAccount', resS.data.loginAccount)
									localStorage.setItem('orgID', resS.data.orgID)
									localStorage.setItem('role', resS.data.role)
									localStorage.setItem('smartCampusToken', resS.data.smartCampusToken)
									localStorage.setItem('userID', resS.data.userID)
									localStorage.setItem('userIdentity', resS.data.userIdentity)
									_this.$message.success('登录成功');
									this.$emit('updateStatus')
									//关闭弹窗
									_this.dialogVisible = false
								} else {
									_this.$message.error(resS.message);
								}
							}).catch(error => {
								console.log(error)
							})
						} else {
							_this.$message.error('该手机号暂未注册,请先注册');
						}
					}).catch(err => {
						console.log(err)
					})
				}
			},
			//获取验证码
			getCode() {
				if (this.account == '') {
					this.$message.error('请填写手机号');
					return
				}
				if (this.account.length != 11) {
					this.$message.error('请填写11位手机号');
					return
				}
				// return this.Verification()
				phoneNumber(this.account).then(res => {
					console.log('获取验证码', res)
					if (res.message == 1) {
						this.Verification()
						verificationCode({
							Register: this.account
						}).then(ress => {
							console.log('获取验证码', ress)
						})
					} else {
						this.$message.error('请先注册账号');
					}
				})
			},
			// 验证码递减
			Verification() {
				if (this.codeTime === 1) {
					this.codeTime = 120
					this.getCodeText = '重新获取'
				} else {
					this.codeTime--
					setTimeout(() => {
						this.Verification()
					}, 1000);
				}
			}
		}
	};
</script>

<style scoped>
	.loginBox {
		min-height: 300px;
		height: auto;
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.loginBox .loginInput {
		height: auto;
		width: 100%;
		margin-top: 30px;
	}

	.loginBox .loginInput .accountBox {
		width: 100%;

		display: flex;
		margin: 20px 0;
		align-items: center;
	}

	.loginBox .loginInput .psBox {
		width: 100%;
		display: flex;
		margin: 30px 0 0;
		align-items: center;
	}

	/deep/ .el-input {
		font-size: 18px !important;
	}

	.loginBtn {
		width: 70%;
		height: 40px;
		border: 1px solid red;
		border-radius: 2500px;
		line-height: 40px;
		text-align: center;
		color: #fff;
		background-color: #ff6500;
	}

	.registerBox {
		margin-top: 20px;
		height: 40px;
		width: 100%;
		text-align: center;
		line-height: 40px;
		color: #ccc;
	}

	.is_psBox {
		height: 30px;
		width: 100%;
		text-align: end;
		color: #ccc;
		line-height: 30px;
		font-size: 16px;
		margin: 10px 0;
	}

	.getCodeBox {}

	/deep/.el-input .el-input__inner {
		height: 30px !important;
		line-height: 30px !important;
	}
</style>


// WEBPACK FOOTER //
// src/components/login.vue